module.exports = "<svg width=\"16\" height=\"10\" viewBox=\"0 0 16 10\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g fill-rule=\"evenodd\">\n    <path d=\"M13.823.28l1.885 1.885-7.51 7.51L6.312 7.79z\"/>\n    <path d=\"M.09 2.165L1.976.28l7.51 7.51L7.6 9.676z\"/>\n  </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/arrow-down-thick.svg
// module id = 775
// module chunks = 1